export const domain = process.env.VUE_APP_AUTH0_DOMAIN || "dev-ffcinptv.eu.auth0.com";
export const clientId = process.env.VUE_APP_AUTH0_CLIENTID ||"clTmaQ1U2mv8WdO7KGrnRlfO3YK1YLTn";
